'use client'

import { useLayoutEffect } from 'react'
import { usePathname } from 'next/navigation'

/** Hostname tab title; not in layout metadata so Next.js hydration does not overwrite it. */
export function VisionDocumentTitle() {
  const pathname = usePathname()

  useLayoutEffect(() => {
    document.title = `Vision | ${window.location.hostname}`
  }, [pathname])

  return null
}
